import {listParents} from "~/store/frontend/group/actions";

const resource = '/v1/group';

export default $axios => ({
  index() {
    return $axios.get(`${resource}`);
  },

  tree() {
    return $axios.get(`${resource}/tree`);
  },

  inviteUser(payload) {
    return $axios.post(`${resource}/invite-user`, payload);
  },

  show(id) {
    return $axios.get(`${resource}/${id}`);
  },

  create(payload) {
    return $axios.post(`${resource}`, payload);
  },

  update(id, payload) {
    return $axios.put(`${resource}/${id}`, payload);
  },

  delete(id) {
    return $axios.delete(`${resource}/${id}`);
  },

  getGroupUsers(id) {
    return $axios.get(`${resource}/${id}/user`);
  },

  deleteUser({groupId, userId}) {
    return $axios.delete(`${resource}/${groupId}/user/${userId}`);
  },

  changeRootUser(payload) {
    return $axios.post(`${resource}/change-root-user`, payload);
  },

  beforeDelete(payload) {
    return $axios.post(`${resource}/user/${payload.userId}`, payload);
  }
});
